
















































import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
} from "vant";
import api from "../../../components/http/api";
import { RecommendInfo } from "./RecommendApi";
import vueQr from "vue-qr";
Vue.use(vueQr);

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
  },
})
export default class BeforeMerchantRecommendHome extends Vue {
  private recommendInfo: RecommendInfo = {} as RecommendInfo;

  private loadNumUp = 5;
  private pageNum = 0;
  private loading: boolean = false;
  private finished: boolean = false;
  private infoList = [];
  private merchantlist = [];

  private showQRCode: boolean = false;
  private showRecommendExplain: boolean = false;

  private qrCodeText: string = "";
  private merchantcode: string = "";

  private shDialog: boolean = false;
  private errDialog: boolean = false;

  protected created() {
    api.post("/weixinmp/xsyx/recommend/getQrinfoList", {}).then((res: any) => {
      this.merchantlist = res.data;
      console.log(this.merchantlist);
      if (this.merchantlist.length === 0) {
        this.errDialog = true;
      } else if (this.merchantlist.length === 1) {
        this.recommendInfo = res.data[0];
        this.$router.push(
          "/main/recommend/merchantRecommendHome/" +
            this.recommendInfo.merchantcode
        );
        console.log(this.merchantlist[0]);
      } else if (this.merchantlist.length > 1) {
        this.shDialog = true;
      }
    });
  }

  protected showInfo() {
    console.log(this.merchantcode);
    if (!this.merchantcode) {
      this.$toast("请选择商户！");
      return;
    } else {
      this.$router.push(
        "/main/recommend/merchantRecommendHome/" + this.merchantcode
      );
    }
  }

  protected onBeforeClose(action: any, resolve: any) {
    if (action === "confirm") {
      if (!this.merchantcode) {
        resolve(false);
      } else {
        resolve(true);
      }
    }
  }
}
